import { RootState } from "../store";

const HotelCartSelectors = {
  getCartInfo: (state: RootState) => state.hotelCartItems,
};

export default HotelCartSelectors;
